import client from '@/clients/restaurant/restaurant-client';
import Qs from 'qs';

export const getNotifications = (filter: object | null = null) =>
  client.get('/notifications', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
  });

export const getBannerNotifications = (filter: object | null = null) =>
  client.get('/banner-notifications', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
  });

export const createBannerNotification = (data: unknown) =>
  client.post(`/banner-notifications`, data);

export const updateBannerNotification = (id: string | number, data: unknown) =>
  client.put(`/banner-notifications/${id}`, data);

export const deleteBannerNotification = (id: string | number) =>
  client.delete(`/banner-notifications/${id}`);

export const toggleBannerNotification = (id: number) => {
  return client.post(`/banner-notifications/${id}/toggle-is-active-state`);
};

export const notificationMarkAsRead = (id: string | number) => {
  return client.put(`/notifications/${id}/mark-as-read`);
};
